import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        navigationLogin: {
            textParagraph: 'Dont have an account?',
            textButton: 'Signup',
            href: '/signup'
        },
        formPasswordReset: {
            textHeadingOne: 'Reset your password',
            textParagraph: 'Provide your email and we will send you a password reset link',
            email: 'Email address',
            errorMessageEmail: 'Invalid email',
            password: 'Password',
            errorMessagePassword: 'Invalid password',
            forgotPassword: 'Forgot password?',
            forgotPasswordHref: '/recover',
            formButtonText: 'Continue',
            backToLogin: 'Send me back to the login screen',
            backToLoginHref: '/login'
        }
    },
    es: {
        navigationLogin: {
            textParagraph: 'No tienes cuenta?',
            textButton: 'Regístrate',
            href: '/signup'
        },
        formSignUp: {
            textHeadingOne: 'Empieza ahora totalmente gratis.',
            textParagraph: 'Construye un chatbot para tu página de Facebook fácil y rápido',
            fullName: 'Nombre completo',
            errorMessageFullName: 'Nombre inválido',
            email: 'Correo',
            errorMessageEmail: 'Correo inválido',
            password: 'Contraseña',
            errorMessagePassword: 'Contraseña incorrecta',
            verifyPassword: 'Verifica tu contraseña',
            errorMessageVerifyPassword: 'Contraseña inválida',
            formButtonText: 'Crea una cuenta'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/pages/PasswordReset/PasswordResetContent.js